'use strict';

const frontendTrackingAgent = require('@edreamsodigeo/frontend-tracking-agent');
const domids = require('./domids');

const getIdFromTarget = (event) => {
    return event?.id?.dataset['id'] || event?.currentTarget?.dataset?.id;
};

const getDOMId = (htmlElement) => htmlElement.dataset['id'];

const trackClickEvent = (event) => {
    if (event && domids.default.has(getIdFromTarget(event))) {
        return frontendTrackingAgent.trackClickEvent(event);
    } else {
        return Promise.reject({error: 'id not present on clicked event'});
    }
};

const trackDOMElementDisplayed = (htmlElement)=> {
    if (htmlElement && domids.default.has(getDOMId(htmlElement))) {
        return frontendTrackingAgent.trackDOMComponentDisplayed(htmlElement);
    } else {
        return Promise.reject({error: 'id not present on DOM element'});
    }
};

const trackClick = (event)=> {
    if (event && event?.data.id && (domids.default.has(event.data.id) || event.data.id.startsWith('home-astid-'))) {
        return frontendTrackingAgent.trackClick(event.data);
    } else {
        return Promise.reject({error: 'id not present on clicked event'});
    }
};

const trackComponentDisplayed = (event)=> {
    if (event && event?.data.id && domids.default.has(event.data.id)) {
        return frontendTrackingAgent.trackComponentDisplayed(event.data);
    } else {
        return Promise.reject({error: 'id not present on clicked event'});
    }
};

module.exports = {
    trackClick,
    trackClickEvent,
    trackDOMElementDisplayed,
    trackComponentDisplayed,
};
